import { Component, elements as $$ } from '@contorion/core';
import { parse } from 'qs';

const PARAMETER_KEY: string = 'f';
const PARAMETER_VALUE: string = 'ft';

export class SetUrlAttributeComponent extends Component {
    protected get paginationLinks(): Array<HTMLAnchorElement> {
        return $$<HTMLAnchorElement>('a', this.element);
    }

    protected get searchFullTextVariation(): string {
        const queryParams: any = parse(window.location.search.replace('?', ''));

        return queryParams.hasOwnProperty(PARAMETER_KEY) ? queryParams.f : PARAMETER_VALUE;
    }

    constructor(protected element: HTMLElement) {
        super(element);

        this.init();
    }

    protected init(): void {
        this.paginationLinks.forEach((element) => {
            element.addEventListener('click',(e) => {
                this.updatePaginationLinks(element, e);
            });
        });
    }

    protected updatePaginationLinks(link: HTMLAnchorElement, e: Event) {
        e.preventDefault();
        if (link.href) {
            link.href =
                `${ link.href }${ link.href.indexOf('?') !== -1 ? '&' : '?' }${ PARAMETER_KEY }=${ this.searchFullTextVariation }`;
            window.location.href = link.href;
        }
    }
}
